import moment from 'moment';
import queryString from 'qs';

const getExportOperatorPresenceRequest = (filter) => {
  const queries = {
    monthYear: moment(filter?.monthYear).format('MM-YYYY'),
    operatorId: filter.id,
  };

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getExportOperatorPresenceRequest;
